<footer class="footer bg-dark fixed-bottom">
    <div class="text-black text-right mr-3">
        <small>&copy; SpeechMED+GI, Taylannas Inc, 2025</small>
    </div>
</footer>
